import { useQuery } from '@tanstack/react-query';
import { getFieldCatalog, getRequiredFields, listSchemaTargets } from './connectorsApi';

export const useSchemaTargetsHandler = () => {
  const query = useQuery({
    queryKey: ['connector-schema-targets'],
    queryFn: listSchemaTargets,
    staleTime: 5 * 60 * 1000,
  });

  return {
    targets: query.data?.targets || [],
    marminApiVersions: query.data?.marminApiVersions || [],
    isLoading: query.isLoading,
  };
};

export const useRequiredFieldsHandler = (target, marminApiVersion) => {
  const query = useQuery({
    queryKey: ['connector-required-fields', target, marminApiVersion],
    queryFn: () => getRequiredFields(target, marminApiVersion),
    enabled: Boolean(target) && Boolean(marminApiVersion),
    staleTime: 5 * 60 * 1000,
  });

  return {
    manifest: query.data,
    isLoading: query.isLoading,
  };
};

export const useFieldCatalogHandler = (target, marminApiVersion) => {
  const query = useQuery({
    queryKey: ['connector-field-catalog', target, marminApiVersion],
    queryFn: () => getFieldCatalog(target, marminApiVersion),
    enabled: Boolean(target) && Boolean(marminApiVersion),
    staleTime: 5 * 60 * 1000,
  });

  return {
    catalog: query.data,
    isLoading: query.isLoading,
  };
};
